export default {

  pushNextRoute (next) {
    sessionStorage.setItem('next', next)
  },

  popNextRoute () {
    const next = sessionStorage.getItem('next')
    sessionStorage.removeItem('next')
    return next
  },

  pushProfileAuthToken (token) {
    sessionStorage.setItem('profile_auth_token', token)
  },

  popProfileAuthToken () {
    const token = sessionStorage.getItem('profile_auth_token')
    sessionStorage.removeItem('profile_auth_token')
    return token
  }
}



// WEBPACK FOOTER //
// ./src/modules/Session.js